export const ServiceIds = {
  Flu: parseInt(process.env.REACT_APP_FLU!),
  FluPrevenar13: parseInt(process.env.REACT_APP_FLU_PREVNAR!),
  FluPPV: parseInt(process.env.REACT_APP_FLU_PPV!),
  PneumoniaWalkIn: parseInt(process.env.REACT_APP_PNEUMONIA_WALK_IN!),
  PneumoniaPPV: parseInt(process.env.REACT_APP_PNEUMONIA_PPV!),
  PneumoniaPrevenar13: parseInt(process.env.REACT_APP_PNEUMONIA_PREVNAR_13!),
  HPV: parseInt(process.env.REACT_APP_HPV!),
  Chickenpox: parseInt(process.env.REACT_APP_CHICKENPOX!),
  MenBBexsero: parseInt(process.env.REACT_APP_MENB_BEXSERO!),
  MenBTrumenba: parseInt(process.env.REACT_APP_MENB_TRUMENBA!),
  CovidAntigen: parseInt(process.env.REACT_APP_COVID_PCR_TEST!),
  CovidGreenPack: parseInt(process.env.REACT_APP_COVID_GREEN_PACK!),
  CovidAmberPack: parseInt(process.env.REACT_APP_COVID_AMBER_PACK!),
  Saxenda: parseInt(process.env.REACT_APP_SAXENDA!),
  ServiceToSkip: process.env.REACT_APP_FLU_SKIP_SERVICE,
  Wegovy: parseInt(process.env.REACT_APP_WEGOVY_SERVICES!),
  HPVSingleDose: parseInt(process.env.REACT_APP_HPV_SINGLE_DOSE!),
  HPVThreeDoses: parseInt(process.env.REACT_APP_HPV_THREE_DOSES!),
};
